var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        staticClass: "wifi-bar wifi-bar-1",
        attrs: { d: "M0 18.8V12.5H3.87522V18.8H0Z", fill: _vm.color },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "wifi-bar wifi-bar-2",
        attrs: {
          d: "M7.76056 18.8V7.25H11.6358V18.8H7.76056Z",
          fill: _vm.color,
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "wifi-bar wifi-bar-3",
        attrs: { d: "M15.5209 18.8V2H19.3961V18.8H15.5209Z", fill: _vm.color },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }